import React, { useEffect } from "react";

const InfiniteScroll = ({ children, onNextLoad }) => {
  useEffect(() => {
    window.addEventListener("scroll", () => {
      // Get the height of the entire document
      var height = document.documentElement.offsetHeight,
        // Get the current offset - how far "scrolled down"
        offset = document.documentElement.scrollTop + window.innerHeight;

      // Check if user has hit the end of page
      // console.log('Height: ' + height);
      // console.log('Offset: ' + offset);
      if (offset + 10 >= height) {
        //if (offset == height) {
        onNextLoad();
      }
    });
  }, []);

  return <React.Fragment>{children}</React.Fragment>;
};

export default InfiniteScroll;
